// extracted by mini-css-extract-plugin
export default {"wrapper":"SubscriptionWidget_wrapper__cAs5e","link":"SubscriptionWidget_link__oetp2"};